import type { PrimativeFieldPropsOmit } from '../../lib/utils';
import type { ColorPickerProps } from '../form/color-picker';

import { useFieldContext } from '../../hooks/use-form-context';
import { ColorPicker } from '../form/color-picker';

export type ColorPickerFieldProps = Omit<ColorPickerProps, PrimativeFieldPropsOmit | 'onColorChange'> & {};

export function ColorPickerFieldRoot(props: ColorPickerFieldProps) {
    const field = useFieldContext<string | null>();

    return (
        <ColorPicker
            id={field.name}
            name={field.name}
            value={field.state.value}
            onChange={field.handleChange}
            onBlur={field.handleBlur}
        >
            {props.children}
        </ColorPicker>
    );
}

ColorPickerFieldRoot.displayName = 'ColorPickerField';

export const ColorPickerField = Object.assign(ColorPickerFieldRoot, {
    Picker: ColorPicker.Picker,
    Preview: ColorPicker.Preview,
    Formats: ColorPicker.Formats,
    HueSlider: ColorPicker.HueSlider,
    SaturationSlider: ColorPicker.SaturationSlider,
    LightnessSlider: ColorPicker.LightnessSlider,
    Manipulations: ColorPicker.Manipulations,
    Harmonies: ColorPicker.Harmonies,
});
